import {
  Account,
  Auth,
  Game,
  Media,
  News,
  Payment,
  Promotion,
  Site,
  Transaction,
} from '@kira-dancer/nadal'

export function useNadal() {
  const site = new Site()
  const payment = new Payment()
  const game = new Game()
  const auth = new Auth()
  const news = new News()
  const account = new Account()
  const transaction = new Transaction()
  const promotion = new Promotion()
  const media = new Media()

  return {
    site,
    payment,
    game,
    auth,
    news,
    account,
    transaction,
    promotion,
    media,
  }
}
